import { init } from "@umengfe/apm";

const UMENG_PID = "6821ce84bc47b67d836321f4";
const isEnabled = process.env.NODE_ENV === "production";
const TRACE_KEY = "traceId";

let initialized = false;
let noiseRejectionIgnored = false;
let traceIdHeaderShimInstalled = false;

export function initUmeng() {
  if (!isEnabled || initialized) return;
  initialized = true;
  setupIgnoreNoiseRejections();
  setupTraceIdHeaderShim();
  init({
    pageFilter: { mode: "ignore", rules: [] },
    pid: UMENG_PID,
    environment: process.env.NODE_ENV,
    traceKey: TRACE_KEY,
    enableCatchJSError: true,
    hookXHR: true,
    hookFetch: true,
    enableRemoteConfig: false,
    sampleConfig: {
      enable: true,
      sampleRate: 100,
      rules: {
        api: { enable: true, sampleRate: 100 },
        error: { enable: true, sampleRate: 100 },
        perf: { enable: true, sampleRate: 10 }
      }
    },
    xhrConfig: { enableReqBody: false },
    fetchConfig: { enableReqBody: false }
  });
}

// 兜底处理全局没有被 .catch() 接住的 Promise reject
function setupIgnoreNoiseRejections() {
  if (typeof window === "undefined" || noiseRejectionIgnored) return;
  noiseRejectionIgnored = true;
  window.addEventListener(
    "unhandledrejection",
    event => {
      if (isNoiseRejection(event.reason)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );
}
// 过滤用户手动关闭/取消弹窗产生的 Promise reject
function isNoiseRejection(reason) {
  if (reason === "cancel" || reason === "close") return true;
  if (!reason || typeof reason !== "object") return false;
  return reason.__CANCEL__ === true || reason.name === "CanceledError" || reason.message === "canceled";
}

// 友盟自动采集 XHR 时能从响应体读取 traceId，不额外新增上报记录
function setupTraceIdHeaderShim() {
  if (typeof window === "undefined" || !window.XMLHttpRequest || traceIdHeaderShimInstalled) return;

  const proto = window.XMLHttpRequest.prototype;
  const rawGetAllResponseHeaders = proto.getAllResponseHeaders;
  const rawGetResponseHeader = proto.getResponseHeader;
  if (typeof rawGetAllResponseHeaders !== "function") return;

  traceIdHeaderShimInstalled = true;

  proto.getAllResponseHeaders = function () {
    const headers = rawGetAllResponseHeaders.apply(this, arguments) || "";
    const traceId = getTraceIdFromXhr(this) || getTraceIdFromHeader(this, rawGetResponseHeader);
    if (!traceId || hasExactTraceHeader(headers)) return headers;
    return `${headers ? headers.trim() + "\r\n" : ""}${TRACE_KEY}: ${traceId}`;
  };

  if (typeof rawGetResponseHeader === "function") {
    proto.getResponseHeader = function (name) {
      const value = rawGetResponseHeader.apply(this, arguments);
      if (value || String(name).toLowerCase() !== TRACE_KEY.toLowerCase()) return value;
      return getTraceIdFromXhr(this) || null;
    };
  }
}

function hasExactTraceHeader(headers) {
  return String(headers)
    .split(/\r?\n/)
    .some(line => line.split(":")[0].trim() === TRACE_KEY);
}

function getTraceIdFromXhr(xhr) {
  try {
    if (!xhr || xhr.readyState !== 4) return "";
    const data = getXhrResponseData(xhr);
    return (data && (data.traceId || data.traceid)) || "";
  } catch (e) {
    return "";
  }
}

function getTraceIdFromHeader(xhr, rawGetResponseHeader) {
  if (typeof rawGetResponseHeader !== "function") return "";
  return rawGetResponseHeader.call(xhr, TRACE_KEY) || "";
}

function getXhrResponseData(xhr) {
  if (xhr.response && typeof xhr.response === "object") return xhr.response;
  if (xhr.responseType && xhr.responseType !== "text") return null;

  const text = xhr.responseText || "";
  if (!text || text.indexOf("traceId") === -1) return null;
  return JSON.parse(text);
}

initUmeng();
